import Glenview1 from '../../../Media/Cibubur/Glenview/Tipe 5.webp'
import Glenview2 from '../../../Media/Cibubur/Glenview//gv6.webp'

const Glenviewimages =[
Glenview1,Glenview2,
]

export default Glenviewimages;